import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { paths } from '@/shared/config/paths';
import { withSuspense } from '../utils';

// 메인섹션
const TopBannerCreate = lazy(() => import('@/pages/mainSection/topBanner/TopBannerCreate'));
const NoticeCreate = lazy(() => import('@/pages/mainSection/notices/NoticeCreate'));
const NoticeEdit = lazy(() => import('@/pages/mainSection/notices/NoticeEdit'));
// 회원
const UserSendEmail = lazy(() => import('@/pages/user/email/UserSendEmail'));
// 대회
const ContestCreate = lazy(() => import('@pages/contest/contest/ContestCreate'));
const ContestUpdate = lazy(() => import('@pages/contest/contest/ContestEdit'));
const ContestSendEmail = lazy(() => import('@pages/contest/email/ContestSendEmail'));
// 프로그램
const ProgramCreate = lazy(() => import('@pages/program/program/ProgramCreate'));
const ProgramEdit = lazy(() => import('@pages/program/program/ProgramEdit'));
const SessionCreate = lazy(() => import('@pages/program/session/SessionCreate'));
const ProgramSendEmail = lazy(() => import('@pages/program/email/ProgramSendEmail'));
// 운영 관리
const NewsCreate = lazy(() => import('@pages/operation/news/NewsCreate'));
const NewsEdit = lazy(() => import('@pages/operation/news/NewsEdit'));
const InstagramCreate = lazy(() => import('@pages/operation/instagram/InstagramCreate'));
const InstagramEdit = lazy(() => import('@pages/operation/instagram/InstagramEdit'));
const YoutubeCreate = lazy(() => import('@pages/operation/youtube/YoutubeCreate'));
const YoutubeEdit = lazy(() => import('@pages/operation/youtube/YoutubeEdit'));
const PrivacyPolicyCreate = lazy(() => import('@pages/operation/privacyPolicy/PrivacyPolicyCreate'));
const TermsOfServiceCreate = lazy(() => import('@pages/operation/termsOfService/TermsOfServiceCreate'));

// 전체 화면 페이지
export const fullScreenRoutes: RouteObject[] = [
	// 메인섹션
	{ // 최상단 배너
		path: paths.mainSection.topBanner.new.path,
		element: withSuspense(TopBannerCreate),
		handle: {
			title: '메인 최상단 배너 대회 등록',
			subTitle: '락앤런 대회·프로그램 중 메인 배너 등록',
		},
	},
	{
		path: paths.mainSection.notice.new.path,
		element: withSuspense(NoticeCreate),
		handle: {
			title: '공지사항 등록',
			subTitle: '락앤런 공지사항 등록하기',
		},
	},
	{
		path: paths.mainSection.notice.edit.path,
		element: withSuspense(NoticeEdit),
		handle: {
			title: '공지사항 수정',
			subTitle: '락앤런 공지사항 수정하기',
		},
	},
	// 회원
	{
		path: paths.user.email.send.path,
		element: withSuspense(UserSendEmail),
		handle: {
			title: '이메일 발송하기',
			subTitle: '락앤런 회원 이메일 발송하기'
		}
	},
	// 대회
	{
		path: paths.contest.new.path,
		element: withSuspense(ContestCreate),
		handle: {
			title: '새 대회 등록',
			subTitle: '새로운 대회 등록하기',
		},
	},
	{
		path: paths.contest.edit.path,
		element: withSuspense(ContestUpdate),
		handle: {
			title: '대회 수정',
			subTitle: '등록한 대회 수정하기',
		},
	},
	{
		path: paths.contest.email.send.path,
		element: withSuspense(ContestSendEmail),
		handle: {
			title: '이메일 발송하기',
			subTitle: '대회 참가자 이메일 발송하기',
		},
	},
	// 프로그램
	{
		path: paths.program.new.path,
		element: withSuspense(ProgramCreate),
		handle: {
			title: '새 프로그램 등록',
			subTitle: '새로운 회차 프로그램 등록하기',
		},
	},
	{
		path: paths.program.edit.path,
		element: withSuspense(ProgramEdit),
		handle: {
			title: '프로그램 수정',
			subTitle: '등록한 프로그램 수정하기',
		},
	},
	// 프로그램 회차
	{
		path: paths.program.session.new.path,
		element: withSuspense(SessionCreate),
		handle: {
			title: '프로그램 회차 등록',
			subTitle: '프로그램 진행 회차 등록하기',
		},
	},
	{
		path: paths.program.email.send.path,
		element: withSuspense(ProgramSendEmail),
		handle: {
			title: '이베일 발송하기',
			subTitle: '프로그램 참가자 이메일 발송하기'
		}
	},
	// 운영 관리
	// 뉴스
	{
		path: paths.operation.news.new.path,
		element: withSuspense(NewsCreate),
		handle: {
			title: '뉴스 등록',
			subTitle: '락앤런 뉴스 게시글 등록하기'
		}
	},
	{
		path: paths.operation.news.edit.path,
		element: withSuspense(NewsEdit),
		handle: {
			title: '뉴스 수정',
			subTitle: '락앤런 뉴스 게시글 수정하기'
		}
	},
	// 인스타
	{
		path: paths.operation.instagram.new.path,
		element: withSuspense(InstagramCreate),
		handle: {
			title: '인스타그램 링크 등록',
			subTitle: '락앤런 인스타그램 링크 등록하기'
		}
	},
	{
		path: paths.operation.instagram.edit.path,
		element: withSuspense(InstagramEdit),
		handle: {
			title: '인스타그램 링크 수정',
			subTitle: '락앤런 인스타그램 링크 수정하기'
		}
	},
	// 유튜브
	{
		path: paths.operation.youtube.new.path,
		element: withSuspense(YoutubeCreate),
		handle: {
			title: '유튜브 링크 등록',
			subTitle: '락앤런 유튜브 링크 등록하기'
		}
	},
	{
		path: paths.operation.youtube.edit.path,
		element: withSuspense(YoutubeEdit),
		handle: {
			title: '유튜브 링크 수정',
			subTitle: '락앤런 유튜브 링크 수정하기'
		}
	},
	// 개인정보 처리방침
	{
		path: paths.operation.privacyPolicy.new.path,
		element: withSuspense(PrivacyPolicyCreate),
		handle: {
			title: '개인정보 처리방침 등록',
			subTitle: '락앤런 개인정보처 리방침 등록하기'
		}
	},
	// 이용약관
	{
		path: paths.operation.termsOfService.new.path,
		element: withSuspense(TermsOfServiceCreate),
		handle: {
			title: '이용약관 등록',
			subTitle: '락앤런 이용약관 등록하기'
		}
	},
];
